import { Radio, RadioChangeEvent } from 'antd';
import React, { Fragment, useMemo } from 'react';
import {useJCommonContext} from "../../JCommonProvider";

export type JRadioStyle = 'BUTTON' | 'CIRCLE'
export type JRadioGroupProps = {

    /**
     * Action to update external module
     * @param value
     */
    onChange?: (value: RadioChangeEvent) => void;

    /**
     * direction
     */
    direction?: 'horizontal' | 'vertical';

    /**
     * elements
     */
    elements?: {
        value: string,
        label: string,
        labelTranslate?: string,
        imageURL?: string
    }[];

    /**
     * radioValue
     */
    radioValue?: any;

    /**
     * name
     */
    name?: string;

    /**
     * disabled
     */
    disabled?: boolean

    /**
     * defaultChecked
     */
    defaultValue?: any
    /**
     * radio style
     */
    style?: JRadioStyle
    /**
     * error message
     */
    errorMessage?: string

};

export const JRadioGroup = ({ name,
    elements,
    radioValue,
    onChange,
    disabled,
    defaultValue,
    style, errorMessage
}: JRadioGroupProps) => {
    const {getImageURL} = useJCommonContext();
    const RadioComponent = useMemo(() => {
        if (style === 'BUTTON') {
            return Radio.Button
        }
        return Radio
    }, [style])
    return (
        <Radio.Group
            name={name}
            disabled={disabled}
            onChange={onChange}
            value={radioValue}
            defaultValue={defaultValue}
        >
            {
                elements?.length ? (
                    elements.map((element, index) => {
                        const label = element?.labelTranslate || element?.label
                        return (
                            <Fragment key={index}>
                                <RadioComponent
                                    name={name}
                                    aria-describedby={errorMessage}
                                    className={element.imageURL && 'with-image'}
                                    value={element.value}
                                >
                                    {
                                        label && (
                                            <div className='radio-text'>{label}</div>
                                        )
                                    }

                                    {element.imageURL && <img src={getImageURL(element.imageURL)} aria-hidden={true} />}

                                </RadioComponent>

                            </Fragment>
                        )
                    })
                ) : (
                    <span></span>
                )
            }
        </Radio.Group>
    );
};
